export interface INestedRoute {
  componentType: EPageComponentTypes;
  route: ERouteLinks;
  isProtected: boolean;
}

export interface IPageBuilderConfig {
  componentType: EPageComponentTypes;
  route: ERouteLinks;
  isProtected: boolean;
  nestedRoutes?: INestedRoute[];
}

export enum ERouteLinks {
  Auth = '/',
  ForgotPassword = '/forgot-password',
  ResetPasswordLink = ':token',
  Dashboard = '/dashboard',
  NotFound = '*',
  AccessDenied = '/access-denied',
  ServerError = '/internal-server-error',
  TermsAndConditions = '/terms-and-conditions',
  ApplyOnline = '/apply-online',
  ApplyOnlineWizard = '/apply-online-wizard',
  CustomOne = '/custom-one',
  CustomTwo = '/custom-two',
  MyProfile = '/my-profile',
  EditAccountData = '/my-profile/EditAccountData',
  MyApplications = '/my-applications',
  ApplicationDetails = '/application/:id',
}

export enum EPageComponentTypes {
  AuthPage = 'AuthPage',
  NotFoundPage = 'NotFoundPage',
  AccessDeniedPage = 'AccessDeniedPage',
  ServerErrorPage = 'ServerErrorPage',
  DashboardPage = 'DashboardPage',
  ForgotPasswordPage = 'ForgotPasswordPage',
  ResetPasswordPage = 'ResetPasswordPage',
  MyProfile = 'MyProfile',
  EditAccountData = 'EditAccountData',
  MyApplicationsPage = 'MyApplicationsPage',
  ApplyOnlinePage = 'ApplyOnlinePage',
  ApplyOnlineWizardPage = 'ApplyOnlineWizardPage',
  CustomOnePage = 'CustomOnePage',
  CustomTwoPage = 'CustomTwoPage',
  ApplicationDetails = 'ApplicationDetailsPage',
}
